__turbopack_context__.v({
  "circle1": "button-module-scss-module__dGAIzG__circle1",
  "circle2": "button-module-scss-module__dGAIzG__circle2",
  "combi1": "button-module-scss-module__dGAIzG__combi1",
  "combi2": "button-module-scss-module__dGAIzG__combi2",
  "danger": "button-module-scss-module__dGAIzG__danger",
  "isFull": "button-module-scss-module__dGAIzG__isFull",
  "isLoading": "button-module-scss-module__dGAIzG__isLoading",
  "large": "button-module-scss-module__dGAIzG__large",
  "link1": "button-module-scss-module__dGAIzG__link1",
  "link2": "button-module-scss-module__dGAIzG__link2",
  "link3": "button-module-scss-module__dGAIzG__link3",
  "long": "button-module-scss-module__dGAIzG__long",
  "medium": "button-module-scss-module__dGAIzG__medium",
  "primary": "button-module-scss-module__dGAIzG__primary",
  "secondary": "button-module-scss-module__dGAIzG__secondary",
  "short": "button-module-scss-module__dGAIzG__short",
  "small": "button-module-scss-module__dGAIzG__small",
  "spinner": "button-module-scss-module__dGAIzG__spinner",
  "tertiary": "button-module-scss-module__dGAIzG__tertiary",
  "trans": "button-module-scss-module__dGAIzG__trans",
  "underline": "button-module-scss-module__dGAIzG__underline",
  "wrapper": "button-module-scss-module__dGAIzG__wrapper",
});
